import { render } from "./SereneTermsAndConditionsPT.vue?vue&type=template&id=3cf34b07"
import script from "./SereneTermsAndConditionsPT.vue?vue&type=script&lang=js"
export * from "./SereneTermsAndConditionsPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__